import { render, staticRenderFns } from "./campaign_prize_dialog.vue?vue&type=template&id=5bfab56d&scoped=true"
import script from "./campaign_prize_dialog.vue?vue&type=script&lang=ts"
export * from "./campaign_prize_dialog.vue?vue&type=script&lang=ts"
import style0 from "./campaign_prize_dialog.vue?vue&type=style&index=0&id=5bfab56d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfab56d",
  null
  
)

export default component.exports